export default "__VITE_ASSET__Dk0VyY_9__"